var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineMegaphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.84871 7C3.82633 7 3 8.07423 3 9.40332V11.0967C3 12.4258 3.82633 13.5 4.84871 13.5H7.45387C7.75549 13.5 8 13.1821 8 12.79V7.70997C8 7.31787 7.75549 7 7.45387 7H4.84871Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.57914 14C5.25929 14 5 14.275 5 14.6143V17.6521C5 18.1567 5.32196 18.6 5.78982 18.7222L6.70738 18.9655L6.70862 18.9658C7.36886 19.1428 8 18.6089 8 17.8963V14.6143C8 14.275 7.74071 14 7.42086 14H5.57914Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4891 5.7136C20.4891 4.80723 19.5607 4.14805 18.5929 4.33053C18.5706 4.33471 18.5486 4.33968 18.5268 4.3454L9.62942 6.68491C9.25638 6.783 9 7.0906 9 7.44009V13.0699C9 13.4002 9.22944 13.6954 9.57442 13.8089L18.3384 16.6914C18.3932 16.7166 18.4516 16.737 18.513 16.7516C19.516 16.9912 20.4891 16.3116 20.4891 15.3844V5.7136Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineMegaphone);
export default __webpack_public_path__ + "static/media/line-megaphone.fd63699ce261cdb6b3f6194abe017846.svg";
export { ForwardRef as ReactComponent };